/* eslint-disable camelcase */
export default {
	sharedNotesButtonText: "Shared",
	privateNotesButtonText: "Private",
	newNoteButtonText: "New note",
	goButtonText: "Go",
	authorizeAndGoButtonText: "Authorize and go",
	uploadButtonText: "Upload",
	orLabel: "or",
	virtualMeetingUrlError: "This URL does not appear to be a valid meeting link. We currently support Zoom, Meet, and Teams. Please verify or try pasting again.",
	virtualMeetingUrlPlaceholder: "Paste meeting URL to record notes",

	oneTimeMeetingOptionText: "New one-time meeting",
	recurringMeetingOptionText: "New recurring meeting",
	manageScheduleOptionText: "Manage schedule",
};
